import React from "react";
import { GRAY_DARKEST } from "../../constants";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { TextField, InputAdornment } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";

const useStyles = makeStyles(() => ({
  textField: {
    width: "100%",
    backgroundColor: GRAY_DARKEST,
    borderColor: GRAY_DARKEST
  }
}));

export default function BasicTextField(props) {
  const {
    label,
    inputType,
    handleChange,
    handleBlur,
    handleKeyPress,
    fieldname,
    value,
    disabled,
    isValidEmail,
    dataid,
    showRemoveButton,
    handleRemove,
    multiline,
    rows,
    helperText,
    allowEnter
  } = props;
  const classes = useStyles();
  const className = props.className ? props.className : classes.textField;

  const errorText =
    inputType === "email" && value !== "" && !isValidEmail(value)
      ? "Please enter a valid email address"
      : null;

  const endAdornment = showRemoveButton ? (
    <InputAdornment position="end">
      <IconButton
        aria-label="toggle password visibility"
        onClick={handleRemove}
        dataid={dataid}
      >
        &times;
      </IconButton>
    </InputAdornment>
  ) : null;

  return (
    <TextField
      helperText={errorText || helperText}
      id={`outlined-basic-${fieldname}`}
      label={label}
      className={className}
      variant="outlined"
      error={errorText}
      margin="none"
      type={inputType || "text"}
      onChange={handleChange}
      onBlur={handleBlur}
      multiline={multiline}
      rows={rows}
      inputProps={{
        fieldname,
        dataid
      }}
      InputProps={{
        endAdornment
      }}
      value={value}
      disabled={disabled}
      onKeyDown={e => {
        if (e.which === 13 && !allowEnter) {
          // Don't refresh the page when they hit 'enter'
          e.preventDefault();
        }
        if (handleKeyPress) {
          handleKeyPress(e);
        }
      }}
    />
  );
}

BasicTextField.propTypes = {
  disabled: PropTypes.bool,
  fieldname: PropTypes.string,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  handleRemove: PropTypes.func,
  inputType: PropTypes.string,
  label: PropTypes.string,
  isValidEmail: PropTypes.bool,
  value: PropTypes.string,
  className: PropTypes.string,
  dataid: PropTypes.string,
  showRemoveButton: PropTypes.bool,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  allowEnter: PropTypes.bool
};
